import React from "react";
import CreateTaskPage from "./CreateTaskPage";
import { StitchFormShell } from "../../shared-ui/StitchFormShell";

export default function StitchCreateTaskPage() {
  return (
    <StitchFormShell
      crumbs={["Operations", "ZTask", "New Task"]}
      title="Create Operational Task"
      description="Define operational objectives, link assets, assign personnel, and set due dates. Submission uses the live ZTask API."
    >
      <CreateTaskPage />
    </StitchFormShell>
  );
}
